import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'containers.OrderPage.components.TaskPage.components.ChangeTaskTypeModal.title',
    defaultMessage: 'Change task type',
  },
  selectTitle: {
    id: 'containers.OrderPage.components.TaskPage.components.ChangeTaskTypeModal.selectTitle',
    defaultMessage: 'Select a task type',
  },
  selectPlaceholder: {
    id: 'containers.OrderPage.components.TaskPage.components.ChangeTaskTypeModal.selectPlaceholder',
    defaultMessage: 'Select a task type',
  },
  loading: {
    id: 'containers.OrderPage.components.TaskPage.components.ChangeTaskTypeModal.loading',
    defaultMessage: 'Loading ...',
  },
  submit: {
    id: 'containers.OrderPage.components.TaskPage.components.ChangeTaskTypeModal.submit',
    defaultMessage: 'Change task type',
  },
})
